import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';

const Root = styled(Horizontal)`
  background: linear-gradient(-20deg, #391885, #c43ba9);
  border-radius: var(--unit);
  padding: var(--half-unit) var(--unit);
`;

export const SpecialEvent = () => (
  <Root>
    <LabelS as="span" color="var(--c-white)">
      <FormattedMessage
        id="ClubShop.Item.Label.SpecialEvent"
        defaultMessage="Special Event"
      />
    </LabelS>
  </Root>
);
